import { Scrollbox, Typography } from "@packages/ds";
import styled from "styled-components";

import Search, { Icon, Close } from "ds/Search";
import { Search as SearchPrimitive } from "ds/Search/Search.styles";

export const Wrapper = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  width: auto;
  padding: 0 33px;
  flex-direction: column;
  min-height: 300px;

  > div {
    flex: 0 0 auto;
  }

  ${Scrollbox} {
    position: relative;
    width: calc(100% + 48px);
    margin: 0 -24px;
    min-height: 0;
    flex: 1 1 0;
  }
`;

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  margin-bottom: 40px;
  flex-direction: column;
`;

export const Title = styled(Typography.Title)`
  margin-bottom: 16px;
`;

export const FiltersWrapper = styled.div`
  display: flex;
  flex: 0;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  .search-wrapper {
    &.search-active {
      .search-image svg rect {
        fill: var(--icon-color-primary-800-fill, var(--color-primary-800));
      }
    }
    input.search::placeholder {
      font-size: 14px;
    }
    @media (min-width: 1280px) {
      width: 400px;
    }
  }
  .outlined .select-box__control,
  .outlined .select-box:hover .select-box__control {
    border-color: transparent;
  }
  @media (min-width: 1010px) {
    flex-direction: row;
  }
`;

export const ResultsWrapper = styled.div`
  box-sizing: border-box;
  padding: 0 24px;
  display: grid;
  grid-template-columns: 338px;
  grid-template-rows: 80px;
  grid-gap: 24px;
  justify-content: center;
  margin: 0 auto;
  .selected {
    position: fixed;
    z-index: 2;
    right: 15%;
    bottom: 10%;
    padding: 30px;
  }
  @media (min-width: 900px) {
    grid-template-columns: repeat(2, 338px);
  }
  @media (min-width: 1280px) {
    grid-template-columns: repeat(3, minmax(272px, 296px));
  }
  @media (min-width: 1440px) {
    grid-template-columns: repeat(3, minmax(296px, 1fr));
  }
  @media (min-width: 1920px) {
    grid-template-columns: repeat(4, minmax(296px, 2fr));
  }
  @media (min-width: 2560px) {
    grid-template-columns: repeat(5, minmax(296px, 2fr));
  }
`;

export const SelectorWrapper = styled.div`
  display: inline-block;
  position: relative;
  z-index: 2;
  margin-right: 15px;
  .input-wrapper {
    width: auto;
  }
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 24px 0;
  z-index: 0;
`;

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 50px;
  padding-bottom: 34px;
`;

export const SelectorsWrapper = styled.div`
  display: flex;
`;

export const SearchInput = styled(Search)`
  min-width: 180px;
  :has(${SearchPrimitive}:focus) {
    ${Icon} {
      fill: var(--mode-vector-neutral-strong);
    }
  }

  ${SearchPrimitive} {
    padding-left: 5px;

    &::placeholder {
      font-size: 14px;
      line-height: 24px;
      color: (--mode-vector-neutral-default);
    }

    &:focus {
      &::placeholder {
        color: var(--mode-text-neutral-weakest);
      }
    }
  }

  ${Icon} {
    fill: var(--mode-vector-neutral-default);
  }

  ${Close} {
    display: none;
  }
`;
